import { UserContext } from '@web-stories-wp/story-editor';
import { StorytellerStoryEditor } from '@src/components/storyEditor';
import { useStudioContext } from '@hooks/studioContext';
import { useStudioApiProvider } from '@hooks/api';
import { useFetchUser, useStoryEditorConfig, useFeatures } from '@hooks';

const useStoryEditor = ({ animatedThumbnail } = {}) => {
  const studioContext = useStudioContext();
  const { user } = useFetchUser();
  const { features } = useFeatures();
  const apiProvider = useStudioApiProvider({
    animatedThumbnail,
    studioContext,
    hasUploadsFeature: features?.useStudioUploadsLibrary?.value === true,
  });
  const config = useStoryEditorConfig({
    animatedThumbnail,
    apiProvider,
    assetType: studioContext?.assetType,
  });

  const isLoading =
    !apiProvider ||
    !user ||
    !config ||
    config.editorConfig.config.apiCallbacks !== apiProvider ||
    Boolean(animatedThumbnail?.isLoading) ||
    Boolean(animatedThumbnail?.isSourceMetadataLoading);

  const storyEditor = (
    <UserContext.Provider value={user}>
      <StorytellerStoryEditor editorConfig={config?.editorConfig} />
    </UserContext.Provider>
  );

  return {
    isLoading,
    storyEditor,
  };
};

export default useStoryEditor;
